import {createRouter, createWebHistory} from 'vue-router'

import HomePage from '@/page/HomePage'
import LoginPage from "@/page/LoginPage.vue";
import WorldOutlookPage from '@/page/WorldOutlookPage'
import DramaPage from '@/page/DramaPage'
import MarketPage from '@/page/MarketPage'
import LoungePage from '@/page/LoungePage'
import AccountPage from '@/page/AccountPage'
import CeremonyPage from '@/page/CeremonyPage.vue'
import DramaDetailPage from '@/page/DramaDetailPage.vue'
import StagePage from '@/page/StagePage.vue'
import BackstagePage from '@/page/BackstagePage.vue'
import GreenRoomPage from "@/page/GreenRoomPage.vue";
import RoleGeneratorPage from "@/page/RoleGeneratorPage.vue";
import StageGeneratorPage from "@/page/StageGeneratorPage.vue";

const routes = [
    {path: '/', component: HomePage},
    {path: '/login', component: LoginPage},
    {path: '/worldOutlook', component: WorldOutlookPage},
    {path: '/drama', component: DramaPage},
    {path: '/market', component: MarketPage},
    {path: '/lounge', component: LoungePage},
    {path: '/account', component: AccountPage},
    {path: '/stage', component: StagePage},
    {path: '/backstage', component: BackstagePage},
    {path: '/greenRoom', component: GreenRoomPage},
    {path: '/ceremony', component: CeremonyPage},
    {path: '/roleGenerator', name: 'roleGenerator', component: RoleGeneratorPage},
    {path: '/stageGenerator', name: 'stageGenerator', component: StageGeneratorPage},
    {path: '/dramaDetail/:dramaId', name: 'dramaDetail', component: DramaDetailPage}
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

let previousRoute = null
router.beforeEach((to, from, next) => {
    previousRoute = from.fullPath
    next()
})

export default router
export { previousRoute }
